<template>
  <div class="hotalbumBox">
    <div class="titlebox">
      <div class="topbox">
        <span class="titlename">热门专辑</span><a class="seeMore" href="/album" target="_blank">查看更多</a>
      </div>
      <div class="bigBox">
        <div v-for="item in list" :key="item.ALBUM_ID" class="AlblumBox">
          <div v-if="item.ALBUM_TYPE_IDS" class="albumntype">
            {{ item.ALBUM_TYPE_IDS }}
          </div>
          <div v-else class="albumntype">
            暂无
          </div>
          <a class="AlbumimgBox" :href="'/albumDetail?albumId='+item.ALBUM_ID" target="_blank">
            <img v-if="item.ALBUM_COVER" :src="item.ALBUM_COVER" alt="">
            <img v-else :src="noIMG" alt="">
          </a>
          <div class="leftBox">
            <a class="albumname" :href="'/albumDetail?albumId='+item.ALBUM_ID" target="_blank">{{ item.ALBUM_NAME }}</a>
            <a class="albumntitle" :href="'/albumDetail?albumId='+item.ALBUM_ID" target="_blank">{{ item.ALBUM_TITLE }}</a>
            <p class="content">
              {{ item.ALBUM_ABSTRACT }}
            </p>
            <span class="hot_time">{{ item.CREATE_DATE |changeTime2 }}</span>
            <span class="el-icon-view viewNumber">   {{ item.ALBUM_READING_SIZE }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { albumInit } from '@/api/api.js'
export default {
  props: ['list'],
  data() {
    return {
      noIMG: require('@/static/home_noimg.png')
    }
  },
  created() {
    albumInit().then(res => {
      for (var i = 0; i < res.data.albumType.length; i++) {
        var item = res.data.albumType[i]
        // console.log(item)
        for (var j = 0; j < this.list.length; j++) {
          if (this.list[j].ALBUM_TYPE_IDS == item.value) {
            this.list[j].ALBUM_TYPE_IDS = item.name
          }
        }
      }
    })
  },
  methods: {
    seemore: function() {
      this.$router.push({ path: '/album' })
    },
    goDetial: function(ID) {
      const { href } = this.$router.resolve({
        path: '/albumDetail',
        name: 'abd',
        query: {
          albumId: ID
        }
      })
      window.open(href, '_blank')
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .titlebox .topbox{
    height: 40px;
    line-height: 40px;
    background-color: #fff;
  }
  .bigBox{

  }
  .albumntype{
    position: absolute;
    top: 20px;
    left: 20px;
    display: inline-block;
    text-align: center;
    height: 18px;
    font-size: 12px;
    color: #ffffff;
    min-width: 58px;
    border-radius: 5px;
    background-color:rgba(51,51,51,.5);
    &:hover{
      background-color:rgba(237,64,64,.5);
    }
  }
    .titlename{
        display: inline-block;
        width: 80px;
        height: 20px;
        line-height: 20px;
        border-left: 2px solid #ed4040;
        padding-left: 10px;
        font-size: 16px;
        margin-left: 20px;
        font-weight: 600;
    }
    .seeMore{
        display: inline-block;
        height: 20px;
        font-size: 15px;
        float: right;
        margin-right:20px;
        color: #b2b2b2;
        cursor: pointer;
        &:hover{
            color: #ed4040;
        }
    }
    .hotalbumBox{
      margin-top: 20px;
      padding-top: 20px;
      margin-bottom: 20px;
    }
    .AlblumBox{
      background-color: #fff;
      position: relative;
        width: 370px;
        height: 194px;
        display: inline-block;
        border: 1px solid #fafafa;
        margin:20px 0 ;
        margin-right: 42px;
        -moz-box-shadow:1px 1px 3px #f3f3f3;
        -webkit-box-shadow:1px 1px 3px #f3f3f3;
        box-shadow:1px 1px 3px #f3f3f3;
      vertical-align: top;
      transition: 0.3s;
      &:hover{
        transform: translate(0,-3px);
      }

        .AlbumimgBox{
          cursor: pointer;
            height: 175px;
            width: 135px;
            font-size: 0;
            margin-top: 10px;
            margin-left: 10px;
            display: inline-block;
            img{
                width: 100%;
              height: 100%;
            }
        }
        .leftBox{
            display: inline-block;
            width: 200px;
            height: 175px;
            margin-top: 10px;
            margin-left: 10px;
            vertical-align: top;
            .albumname{
                font-size: 18px;
                color: #333333;
                font-weight: 600;
                display: inline-block;
                padding:10px 0;
              cursor: pointer;
            }
            .albumntitle{
                font-size: 16px;
                color: #333333;
                display: inline-block;
              cursor: pointer;
            }
            .content{
                height: 50px;
                display: inline-block;
                font-size: 12px;
                color: #666;
                margin-top: 10px;
                margin-bottom: 25px;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 3;
                overflow: hidden;
            }
            .hot_time{
                font-size: 12px;
                color: #b2b2b2;
                display: inline-block;
                width: 87px;
            }
            .viewNumber{
                display: inline-block;
                font-size: 12px;
                color: #b2b2b2;
                width: 55px;
                text-align: right;
                float: right;
                margin-top: 5px;
            }
        }
    }
  .AlblumBox:nth-child(3n){
    margin-right: 0;
  }
</style>

<!--手机端样式-->
<style rel="stylesheet/scss" lang="scss" scoped>
  @media screen and (max-width: 750px) {
    .AlblumBox{
      width: 94%;
      margin: 3%;
      .leftBox{
        width: calc( 94vw - 158px);
      }
    }
  }
</style>
